import React, { useState, Fragment } from "react";
import CardAccordion from "../../component/Card/CardAccordion";
import Footer from "../../component/Other/Footer";
import Navbar from "../../component/Other/Navbar";
const Faq = (props) => {
    const [accordion, setAccordion] = useState();

    const setAccordionSelect = (e) => {
        if (e === accordion) {
            setAccordion(0);
        } else {
            setAccordion(e);
        }
    };

    const [accordionData] = useState([
        {
            title: "What is PavilionManager?",
            desc: "PavilionManager is a multi-tenant platform for running construction and capital projects from one place. It brings organizations, projects, admins, workers, milestones, tasks, finance, procurement, client artefacts and collaboration into a shared project workspace.",
        },
        {
            title: "How does the project platform work?",
            desc: "Each project can use published configuration for navigation, schema fields, views, workflows, permissions and automations. Teams can keep standard project controls while shaping each project workspace to match its delivery process.",
        },
        {
            title: "Who uses PavilionManager?",
            desc: "Organizations use PavilionManager to manage project owners, admins, workers and clients. Admins can manage projects and workers, while project teams can track assigned work, updates, chats, programme data and delivery progress.",
        },
        {
            title: "What project work can be managed?",
            desc: "Teams can manage milestones, project tasks, assigned workers, status, priority, progress, comments, timers, programme files, geo validation audits, timeline posts and project analytics.",
        },
        {
            title: "Does PavilionManager include finance and procurement?",
            desc: "Yes. PavilionManager supports ledger summaries, deposits, payment requests, approval flows, payment proof, journal exports, procurement requests, purchase orders, goods receipt and BoQ progress tracking.",
        },
       
    ]);
    return (
        <Fragment>
            <div className="overflow-hidden">
                <Navbar type="light" />
                <section className="bg__blue">
                    <div className="container text-center">
                        <h2 className="bold font__size--40 text__40-1024 text__40-md text__40-mm color__white">Frequently asked questions</h2>
                        <p className="normal font__size--16 text__16-1024 mb-0 color__white">Everything you need to know about the project platform.</p>
                    </div>
                </section>


                <section>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8">
                                <h5 className="bold font__size--24 text__24-1024 mb-3">Common questions about <br />
                                    PavilionManager</h5>

                                {accordionData.map((obj, i) => {
                                    return (
                                        <div className="mb-2">
                                            <CardAccordion
                                                id={i + 1}
                                                title={obj.title}
                                                desc={obj.desc}
                                                accordion={accordion}
                                                setAccordionSelect={(e) => setAccordionSelect(e)}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </section>

                <Footer />
            </div >
        </Fragment >
    );
};

export default Faq;
